<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Ajuste de parámetros</span>
      </h5>
    </div>
    <div class="card" v-if="userParams.length > 0">
      <div class="card-header p-2 ml-2 mt-2">
        <h5>
          <strong>Crédito</strong>
        </h5>
      </div>
      <div class="card-body pb-0">
        <div class="mt-1 d-flex flex-nowrap" v-for="(item, index) in userParams" :key="index">
          <div class="mr-2 my-auto">
            <div class="custom-control custom-switch">
              <input type="checkbox" :checked="!disabledParam.includes(item.id)" class="custom-control-input"
                :id="item.id" @change="addParam(item)">
              <label class="custom-control-label" :for="item.id">Habilitar crédito para realizar compras en cafetería.</label>
              <div>
                <h6><small class="text-secondary">El crédito otrogado por la institución es de {{ currencyFormat(item.amount) }}.</small></h6>
              </div>
            </div>
          </div>
        </div>
        <div class="p-0 m-0">
          <b-button type="submit" variant="primary" class="float-right mr-3 mb-3 my-2" @click="activeCredit()">Guardar cambios</b-button>
        </div>
      </div>
    </div>
    <empty-table v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiClient2 from '@/services/axios/v2'
import { ToastFire } from '@/services/utilities/swal'
import { consts, showErrorMessage } from '@/services/utilities'
import emptyTable from '@/components/custom/cardEmptyList'
import store from 'store'
import { currencyFormatPesos } from '../../../services/utilities'

export default {
  name: 'paramUser',
  components: { emptyTable },
  data() {
    return {
      userParams: [],
      disabledParam: [],
      consts,
      formParam: [],
      userRoles: [],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    activeCredit() {
      if (this.formParam.length === 0) {
        ToastFire('warning', 'Se esperaban cambios')
      } else {
        apiClient2.patch(`userSpecificParam/${this.user.id}`, { sentParams: this.formParam }).then((response) => {
          ToastFire('success', 'Parámetro actualizado con éxito')
        }).catch(error => {
          ToastFire('warning', showErrorMessage(error))
        })
      }
    },
    addParam(item) {
      const indexDisabled = this.disabledParam.indexOf(item.id)
      if (indexDisabled >= 0) {
        this.disabledParam.splice(indexDisabled, 1)
        let notAdd = true
        this.formParam.forEach((element) => {
          if (element.idProfileParam === item.id) {
            element.active = true
            notAdd = false
          }
        })
        if (notAdd) {
          this.formParam.push({
            ...(item.iduserSpecificParam && { id: item.iduserSpecificParam }),
            idSpecificParam: item.id,
            active: true,
          })
        }
      } else {
        this.disabledParam.push(item.id)
        let notAdd = true
        this.formParam.forEach((element) => {
          if (element.idProfileParam === item.id) {
            element.active = false
            notAdd = false
          }
        })
        if (notAdd) {
          this.formParam.push({
            ...(item.iduserSpecificParam && { id: item.iduserSpecificParam }),
            idSpecificParam: item.id,
            active: false,
          })
        }
      }
    },
  },
  created() {
    this.userRoles = JSON.parse(store.get('userData')).roles
    if (this.userRoles.includes(consts.rolesText.VISITANTE)) {
      return ToastFire('warning', 'Rol no permitido')
    }
    apiClient2.get('userSpecificParam').then(response => {
      if (response.data.data.length > 0) {
        for (const param of response.data.data) {
          if (![consts.SPECIFIC_PARAM.CREDIT].includes(param.key)) continue
          this.userParams.push({
            id: param.id,
            key: param.key,
            ...((param.userParam.length > 0 && param.userParam[0].userSpecificParam.id) && { iduserSpecificParam: param.userParam[0].userSpecificParam.id }),
            ...(param.credit && { amount: param.credit }),
          })
          if (param.userParam.length === 0 && consts.SPECIFIC_PARAM.CREDIT === param.key) {
            this.disabledParam.push(param.id)
          }
          for (const userParam of param.userParam) {
            if (userParam.userSpecificParam && userParam.userSpecificParam.active !== true) {
              this.disabledParam.push(param.id)
            }
          }
        }
      }
    })
  },
}
</script>

<style scoped></style>
